// Segment and undersegment per client account (transfer agent account number). Accounts are not listed per fund since an account has the same segment in every fund.
// Client accounts that are not listed here are not part of any segment yet

export interface AumSegment {
    segment: string;
    undersegment: string;
}

export const aumSegments = ["Institutioner", "Plattform/Retail", "Allokerare", "White-label"];

export const aumSegmentByClientAccount: Record<string, AumSegment> = {
    "54800004409": { segment: "Institutioner", undersegment: "Pensionsstiftelser/försäkring" },
    "54800004417": { segment: "Institutioner", undersegment: "Pensionsstiftelser/försäkring" },
    "54800004433": { segment: "Institutioner", undersegment: "Pensionsstiftelser/försäkring" },
    "54800004441": { segment: "Institutioner", undersegment: "Pensionsstiftelser/försäkring" },
    "54800004573": { segment: "Institutioner", undersegment: "Pensionsstiftelser/försäkring" },
    "54800004611": { segment: "Plattform/Retail", undersegment: "Other" },
    "54800004638": { segment: "Institutioner", undersegment: "Pensionsstiftelser/försäkring" },
    "54800004697": { segment: "Institutioner", undersegment: "Pensionsstiftelser/försäkring" },
    "54800004735": { segment: "Institutioner", undersegment: "Stiftelser/övrigt" },
    "54800007807": { segment: "Institutioner", undersegment: "Fackförbund" },
    "54800007831": { segment: "Institutioner", undersegment: "Pensionsstiftelser/försäkring" },
    "54800007858": { segment: "Allokerare", undersegment: "Diskretionär förvaltning" },
    "54800007866": { segment: "Institutioner", undersegment: "Stiftelser/övrigt" },
    "54800007874": { segment: "Plattform/Retail", undersegment: "Other" },
    "54800007947": { segment: "Plattform/Retail", undersegment: "Other" },
    "54800007955": { segment: "Allokerare", undersegment: "Diskretionär förvaltning" },
    "54800008080": { segment: "Institutioner", undersegment: "Pensionsstiftelser/försäkring" },
    "54800008196": { segment: "Institutioner", undersegment: "Offentlig sektor" },
    "54800008269": { segment: "Institutioner", undersegment: "Pensionsstiftelser/försäkring" },
    "54800008285": { segment: "Institutioner", undersegment: "Pensionsstiftelser/försäkring" },
    "54800008293": { segment: "Plattform/Retail", undersegment: "Other" },
    "54800008307": { segment: "Institutioner", undersegment: "Pensionsstiftelser/försäkring" },
    "54800008315": { segment: "Allokerare", undersegment: "Diskretionär förvaltning" },
    "54800008323": { segment: "Institutioner", undersegment: "Offentlig sektor" },
    "54800008331": { segment: "Allokerare", undersegment: "Diskretionär förvaltning" },
    "54800008382": { segment: "Institutioner", undersegment: "Offentlig sektor" },
    "54800008471": { segment: "Institutioner", undersegment: "Fackförbund" },
    "54800008528": { segment: "Plattform/Retail", undersegment: "Other" },
    "54800008536": { segment: "Plattform/Retail", undersegment: "Other" },
    "54800008544": { segment: "Institutioner", undersegment: "Pensionsstiftelser/försäkring" },
    "54800008587": { segment: "Allokerare", undersegment: "Diskretionär förvaltning" },
    "54800008595": { segment: "Institutioner", undersegment: "Stiftelser/övrigt" },
    "54800008617": { segment: "Institutioner", undersegment: "Fackförbund" },
    "54800008633": { segment: "Plattform/Retail", undersegment: "Other" },
    "54800008668": { segment: "Institutioner", undersegment: "Other" },
    "54800008676": { segment: "Plattform/Retail", undersegment: "Other" },
    "54800008692": { segment: "Institutioner", undersegment: "Other" },
    "54800008706": { segment: "Plattform/Retail", undersegment: "Other" },
    "54800009001": { segment: "Institutioner", undersegment: "Pensionsstiftelser/försäkring" },
    "54800009060": { segment: "Institutioner", undersegment: "Stiftelser/övrigt" },
    "54800010026": { segment: "Plattform/Retail", undersegment: "Other" },
    "54800010190": { segment: "Plattform/Retail", undersegment: "Other" },
    "54800010220": { segment: "Allokerare", undersegment: "Other" },
    "54800010239": { segment: "Institutioner", undersegment: "Offentlig sektor" },
    "54800010271": { segment: "Plattform/Retail", undersegment: "Other" },
    "54800010514": { segment: "Institutioner", undersegment: "Pensionsstiftelser/försäkring" },
    "54800010522": { segment: "Institutioner", undersegment: "Pensionsstiftelser/försäkring" },
    "54800010662": { segment: "Institutioner", undersegment: "Pensionsstiftelser/försäkring" },
    "54800010670": { segment: "Plattform/Retail", undersegment: "Other" },
    "54800010689": { segment: "Plattform/Retail", undersegment: "Stiftelser/övrigt" },
    "54800010697": { segment: "Allokerare", undersegment: "Other" },
    "54800010700": { segment: "Allokerare", undersegment: "Other" },
    "54800010735": { segment: "Allokerare", undersegment: "Other" },
    "54800010743": { segment: "Allokerare", undersegment: "Other" },
    "54800010751": { segment: "Allokerare", undersegment: "Other" },
    "54800010778": { segment: "Allokerare", undersegment: "Other" },
    "54800010786": { segment: "Allokerare", undersegment: "Other" },
    "54800011006": { segment: "White-label", undersegment: "Other" },
    "54800011014": { segment: "White-label", undersegment: "Other" },
    "54800011227": { segment: "Plattform/Retail", undersegment: "Other" },
    "54800011340": { segment: "Plattform/Retail", undersegment: "Other" },
    "54800011502": { segment: "Plattform/Retail", undersegment: "Other" },
    "54800012011": { segment: "Institutioner", undersegment: "Offentlig sektor" },
    "54800012079": { segment: "Allokerare", undersegment: "Other" },
    "54800012092": { segment: "Plattform/Retail", undersegment: "Other" },
    "54800012093": { segment: "Plattform/Retail", undersegment: "Other" },
    "54800012125": { segment: "Institutioner", undersegment: "Offentlig sektor" },
    "54800012127": { segment: "Institutioner", undersegment: "Offentlig sektor" },
    "54800012146": { segment: "Institutioner", undersegment: "Pensionsstiftelser/försäkring" },
    "54800012170": { segment: "Plattform/Retail", undersegment: "Other" },
    "54800012202": { segment: "Allokerare", undersegment: "Other" },
    "54800012204": { segment: "Plattform/Retail", undersegment: "Other" },
    "54800012207": { segment: "Allokerare", undersegment: "Other" },
    "54800012216": { segment: "Institutioner", undersegment: "Other" },
    "54800012226": { segment: "Allokerare", undersegment: "Diskretionär förvaltning" },
    "54800012227": { segment: "Allokerare", undersegment: "Diskretionär förvaltning" },
    "54800012229": { segment: "Allokerare", undersegment: "Diskretionär förvaltning" },
    "54800012230": { segment: "Allokerare", undersegment: "Diskretionär förvaltning" },
    "54800012231": { segment: "Allokerare", undersegment: "Diskretionär förvaltning" },
    "54800012232": { segment: "Allokerare", undersegment: "Diskretionär förvaltning" },
    "54800012233": { segment: "Allokerare", undersegment: "Diskretionär förvaltning" },
    "54800012234": { segment: "Allokerare", undersegment: "Diskretionär förvaltning" },
    "54800012245": { segment: "Plattform/Retail", undersegment: "Other" },
    "54800012247": { segment: "Plattform/Retail", undersegment: "Other" },
    "6600000001": { segment: "Institutioner", undersegment: "Offentlig sektor" },
    "6600000002": { segment: "Allokerare", undersegment: "Diskretionär förvaltning" },
    "6600000003": { segment: "Institutioner", undersegment: "Stiftelser/övrigt" },
    "6600000004": { segment: "Institutioner", undersegment: "Stiftelser/övrigt" },
    "6600000005": { segment: "Institutioner", undersegment: "Stiftelser/övrigt" },
    "77600000052": { segment: "Allokerare", undersegment: "Other" },
    "77600000053": { segment: "White-label", undersegment: "Other" },
    "77600000054": { segment: "Allokerare", undersegment: "Other" },
    "77600000055": { segment: "Plattform/Retail", undersegment: "Other" },
    "77600000056": { segment: "Plattform/Retail", undersegment: "Other" },
    "77600000057": { segment: "Plattform/Retail", undersegment: "Other" },
    "77600000058": { segment: "Plattform/Retail", undersegment: "Other" },
    "77600000059": { segment: "Plattform/Retail", undersegment: "Other" },
    "77600000060": { segment: "Institutioner", undersegment: "Pensionsstiftelser/försäkring" },
    "77600000061": { segment: "Plattform/Retail", undersegment: "Other" },
    "77600000064": { segment: "Plattform/Retail", undersegment: "Other" }
};
